import axios from 'axios'

const getRoleList = async (organizationId) => {
    try {
        const response = await axios.get(
          `/organization/${organizationId}/role`
        );
        return response.data;
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
}
export default getRoleList